import React, { useEffect, useState } from 'react'
import Marquee from 'react-double-marquee'
import { Skeleton } from 'primereact/skeleton'
import FormComponent from '../../components/FormComponent/FormComponent'
import { FormSkeletons } from './FormSkeletons'
import Logo from '../../components/Logo/Logo'
import FormMini from './FormMini/FormMini'

import './Form.scss'
import { IconsSvg } from '../../components/IconsSvg/IconsSvg'
import { renderToStaticMarkup } from "react-dom/server";
import { Checkbox } from 'primereact/checkbox';

const Form = ({ data }) => {
    const [selectedTariff, setSelectedTariff] = useState(null)
    const [tariffs, setTariffs] = useState(null)
    const [isFormSubmitted, setIsFormSubmitted] = useState(false)
    const [checked, setChecked] = useState(false);

    const tabIcon = (icon) => {
        const svgString = encodeURIComponent(renderToStaticMarkup(<IconsSvg name={icon} fill={data?.color} />));
        return { backgroundPosition: 'right', backgroundRepeat: 'no-repeat', backgroundImage: `url("data:image/svg+xml,${svgString}")` }
    }

    const showTariffs = () => {
        const tariffBlocks = tariffs
            ?.sort((a, b) => (a.title > b.title ? 1 : -1))
            ?.sort((a, b) => (a.current_price > b.current_price ? 1 : -1))
            ?.map((tariff) => {
                // let formatTitle = tariff.title?.slice(0, 30)
                // if (formatTitle?.length < tariff.title?.length) {
                //     formatTitle += '...'
                // }
                return (
                    <div key={tariff.id} style={tabIcon(tariff.icon)} className={tariff === selectedTariff ? 'form-tariffs-block active' : 'form-tariffs-block'} onClick={() => selectTariff(tariff)}>
                        <div> {tariff.title}</div>
                    </div>
                )
            })
        return tariffBlocks
    }

    const content = (block) => {
        const mapped = Object.entries(block).map(([k, v]) => {
            return (
                <>
                    <p  className='subtitle'
                        key={k}
                        dangerouslySetInnerHTML={{
                            __html: `${k}`,
                        }}
                    ></p>
                    <p
                        key={v}
                        dangerouslySetInnerHTML={{
                            __html: `${v}`,
                        }}
                    ></p>
                </>
            )
        })
        return mapped
    }

    const defaultTariff = () => {
        const defaultTab = data?.tabs?.find((tab) => tab.is_default === true)
        return defaultTab
    }
    useEffect(() => {
        setTariffs(data?.tabs)

        if (defaultTariff()) {
            setSelectedTariff(defaultTariff)
        } else {
            setSelectedTariff(data?.tabs[0])
        }
    }, [data])

    const selectTariff = (tariff) => {
        setSelectedTariff(tariff)
    }

    return (
        <>
            {!data && <FormSkeletons />}
            {data?.tabs?.length < 2 && <FormMini data={data} />}
            {data?.tabs?.length >= 2 && (
                <div className="form col-12">
                    <div className="form-header">
                        <h1 className="title">{data?.title}</h1>
                        <div className="start">
                            {data?.start_title && data?.start_title + ':'} <span>{data?.course_start_date}</span>
                        </div>
                    </div>
                    {data?.description && <p className="form-description mb-5">{data?.description}</p>}

                    <div className="form-tariffs mb-4">
                        {tariffs?.length > 1 && showTariffs()} {!tariffs && <Skeleton width="680px" height="80px" />}
                    </div>
                    <div className="form-body grid">
                        <h2 className="col-12 form-body-title">{selectedTariff?.title}</h2>
                        <div className="form-body-container col-12 lg:col-8 ">
                            <div className="form-body-content-container">
                                {selectedTariff?.content?.map((block, index) => {
                                    return (
                                        <div key={'qwe' + index} className="form-body-content mb-5">
                                            {content(block)}
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        <div className="col-12 lg:col-4">{<FormComponent data={data} selectedTariff={selectedTariff} isFormSubmitted={isFormSubmitted} setIsFormSubmitted={setIsFormSubmitted} checked={checked} />}</div>
                    </div>
                    <div className="form-footer grid ">
                        <div className="col-12 lg:col-8 lg:pl-2 ">
                            {data?.is_marquee && (
                                <div
                                    className="ticker"
                                    style={{
                                        width: '100%',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    <Marquee scrollWhen="overflow" direction="left">
                                        {data?.description}
                                    </Marquee>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            <div>
                <Logo data={data} />
            </div>
        </>
    )
}

export default Form
